import { FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore, initializeFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
} from "~/src/constant/env";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

/**
 * Firebase初期化
 */
export function initializeFirebaseApp(): FirebaseApp {
  return !getApps().length ? initializeApp(firebaseConfig) : getApp();
}
// FirebaseAppの保持
export const firebaseApp = initializeFirebaseApp();

/**
 * Firestore保持
 */
initializeFirestore(firebaseApp, {
  // undefinedなフィールドのあるデータを保存する際、エラーを無視する
  ignoreUndefinedProperties: true,
});
export const firestore = getFirestore(firebaseApp);

/**
 * FirebaseAuthの保持
 */
export const firebaseAuth = getAuth(firebaseApp);

/**
 * Firebase Functionsの保持（asia-northeast1リージョン）
 */
export const firebaseFunctions = getFunctions(firebaseApp, "asia-northeast1");

/**
 * Cloud Storage for Firebaseの保持
 */
export const firebaseStorage = getStorage(firebaseApp);

/**
 * 開発環境のみ。エミュレータ接続
 */
console.log("[Firebase] NODE_ENV:", process.env.NODE_ENV);
if (process.env.NODE_ENV === "development") {
  console.log("[Firebase] Connecting to emulators...");
  connectFirestoreEmulator(firestore, "localhost", 8080);
  connectAuthEmulator(firebaseAuth, "http://localhost:9099");
  connectFunctionsEmulator(firebaseFunctions, "localhost", 5001);
  connectStorageEmulator(firebaseStorage, "localhost", 9199);
  console.log("[Firebase] Emulators connected");
}
